import {
  Card,
  Grid,
  Stack,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Avatar,
  IconButton,
} from '@mui/material';
import { Box } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from '../../../store';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Shape as IShape } from '../../../store/shape/api/interface';
import { useFormik } from 'formik';
import { createShape, getShape, patchShape } from '../../../store/shape/api';
import { setStatus } from '../../../store/shape/shapeSlice';
import { useEffect, useRef } from 'react';
import { decryptString, getAssetURl } from '../../../utils/url';
import Loader from '../../../components/Loader';
import { omit } from 'lodash';
import {
  setStatus as selectShapeSetStatus,
  reset as resetSelectShapeReset,
} from '../../../store/selectShape/selectShapeSlice';
import shapeSchema from '../../../validation/shapeSchema';
import { NumericFormatCustom } from '../../../components/NumericCustomFormatter';
import { SHAPE_FRAME_TYPE } from '../../../constants';
import { DocumentType } from '../../../enum';
import { uploadAssets } from '../../../utils/uploadAssets';

const ShapeForm = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const params: any = useParams();
  const location = useLocation();
  const state = location.state as IShape; // Type Casting, then you can get the params passed via router

  const isAddMode = !params?.id;
  const { isLoading } = useAppSelector((state) => state.shape);
  const { accessToken } = useAppSelector((state) => state.auth);
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );
  const previewSizeInputRef = useRef<HTMLInputElement | null>(null);
  // const [response, setResponse] = useState<any>();

  const {
    handleSubmit,
    values,
    setValues,
    handleChange,
    setFieldValue,
    resetForm,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      id: '',
      labelEn: '',
      labelAr: '',
      code: '',
      subLabelEn: '',
      subLabelAr: '',
      descriptionEn: '',
      descriptionAr: '',
      previewUrl: '',
      previewSizeUrl: '',
      // toppingRatio: '',
      size: '',
      price: '',
      discountedPrice: '',
      // toppingPriceRatio: '',
      frameType: '',
      kg: '',
      // slicedImg: '',
      topImg: '',
      frontImg: '',
      // slicedColorImg: '',
      topColorImg: '',
      frontColorImg: '',
      position: '',
      // isNew: false,
      // isOnDemandAllowed: false,
      activeState: true,
    },
    validationSchema: shapeSchema,
    onSubmit: async (values) => {
      try {
        if (isAddMode) {
          const reqBody = omit(values, ['id']);
          await dispatch(createShape(reqBody)).unwrap();
        }
        if (!isAddMode) {
          const reqBody: any = values;
          delete reqBody.createdAt;
          delete reqBody.createdBy;
          delete reqBody.updatedAt;
          delete reqBody.updatedBy;
          delete reqBody.isBestSeller;
          delete reqBody.isTrending;
          delete reqBody.badges;
          delete reqBody.bestSellerScore;
          delete reqBody.trendingScore;
          delete reqBody.badgesUpdatedAt;
          await dispatch(patchShape(reqBody)).unwrap();
        }
        resetForm();
        dispatch(setStatus({ status: 'idle' }));
        dispatch(resetSelectShapeReset());
        dispatch(selectShapeSetStatus({ status: 'idle' }));
        navigation('/shape');
      } catch (error: any) {}
    },
  });

  useEffect(() => {
    const fetchById = async () => {
      if (isAddMode) return;

      if (state) {
        setValues(state);
        // setResponse(state);
      } else {
        try {
          const decodeParam = decryptString(params.id);
          const record = await dispatch(getShape({ id: decodeParam })).unwrap();
          setValues(record);
          // setResponse(record);
        } catch (error: any) {
          navigation('/shape');
        }
      }
    };
    fetchById();
  }, [dispatch, isAddMode, navigation, params?.id, setValues, state]);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    documentType: string,
    field: string
  ) => {
    if (event.target.files?.[0]) {
      const uploadResult: any = await uploadAssets(
        event.target.files?.[0],
        documentType,
        accessToken
      );
      if (uploadResult?.data?.id) {
        setFieldValue(field, uploadResult?.data?.keypath);
      }
    }
  };

  return (
    <Grid
      container
      spacing={3}
    >
      <Grid
        item
        xs={12}
        md={12}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <form onSubmit={handleSubmit}>
            <Card sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  },
                }}
              >
                <TextField
                  fullWidth
                  label={'Label English'}
                  name='labelEn'
                  id='labelEn'
                  onChange={handleChange}
                  value={values.labelEn}
                  error={Boolean(errors.labelEn && touched.labelEn)}
                  helperText={
                    Boolean(errors.labelEn && touched.labelEn) && errors.labelEn
                  }
                />
                <TextField
                  fullWidth
                  label={'Label Arabic'}
                  name='labelAr'
                  id='labelAr'
                  onChange={handleChange}
                  value={values.labelAr}
                  error={Boolean(errors.labelAr && touched.labelAr)}
                  helperText={
                    Boolean(errors.labelAr && touched.labelAr) && errors.labelAr
                  }
                />

                <TextField
                  fullWidth
                  label={'Sub Label English'}
                  name='subLabelEn'
                  id='subLabelEn'
                  onChange={handleChange}
                  value={values.subLabelEn}
                  error={Boolean(errors.subLabelEn && touched.subLabelEn)}
                  helperText={
                    Boolean(errors.subLabelEn && touched.subLabelEn) &&
                    errors.subLabelEn
                  }
                />

                <TextField
                  fullWidth
                  label={'Sub Label Arabic'}
                  name='subLabelAr'
                  id='subLabelAr'
                  onChange={handleChange}
                  value={values.subLabelAr}
                  error={Boolean(errors.subLabelAr && touched.subLabelAr)}
                  helperText={
                    Boolean(errors.subLabelAr && touched.subLabelAr) &&
                    errors.subLabelAr
                  }
                />

                <TextField
                  fullWidth
                  label={'Code'}
                  name='code'
                  id='code'
                  onChange={handleChange}
                  value={values.code}
                  error={Boolean(errors.code && touched.code)}
                  helperText={
                    Boolean(errors.code && touched.code) && errors.code
                  }
                />

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={values?.previewUrl ? 8.5 : 12}
                    sm={values?.previewUrl ? 8.5 : 12}
                  >
                    <TextField
                      type='file'
                      fullWidth
                      name='previewUrl'
                      id='previewUrl'
                      onChange={(e) =>
                        handleFileChange(
                          e as React.ChangeEvent<HTMLInputElement>,
                          DocumentType.Shape,
                          'previewUrl'
                        )
                      }
                      inputProps={{ multiple: false, accept: 'image/*' }}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      label={'Preview URL'}
                      error={Boolean(errors.previewUrl && touched.previewUrl)}
                      helperText={
                        Boolean(errors.previewUrl && touched.previewUrl) &&
                        errors.previewUrl
                      }
                    />
                  </Grid>
                  {values?.previewUrl && (
                    <Grid
                      item
                      xs={3.5}
                      sm={3.5}
                    >
                      <Avatar
                        imgProps={{ crossOrigin: 'anonymous' }}
                        src={getAssetURl(values?.previewUrl, assetUrl)}
                        sx={{
                          borderRadius: 'unset',
                          m: 1,
                          objectFit: 'contain',
                          '& img': { objectFit: 'contain' },
                          width: { xs: '75px', sm: '100px' },
                          height: 50,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>

              <Box sx={{ pt: 2.5 }}>
                <TextField
                  fullWidth
                  label={'English Description'}
                  name='descriptionEn'
                  id='descriptionEn'
                  onChange={handleChange}
                  value={values.descriptionEn}
                  error={Boolean(errors.descriptionEn && touched.descriptionEn)}
                  helperText={
                    Boolean(errors.descriptionEn && touched.descriptionEn) &&
                    errors.descriptionEn
                  }
                />
              </Box>

              <Box sx={{ pt: 2.5, pb: 2.5 }}>
                <TextField
                  fullWidth
                  label={'Arabic Description'}
                  name='descriptionAr'
                  id='descriptionAr'
                  onChange={handleChange}
                  value={values.descriptionAr}
                  error={Boolean(errors.descriptionAr && touched.descriptionAr)}
                  helperText={
                    Boolean(errors.descriptionAr && touched.descriptionAr) &&
                    errors.descriptionAr
                  }
                />
              </Box>

              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  },
                }}
              >
                <FormControl
                  error={Boolean(touched?.frameType && errors?.frameType)}
                >
                  <InputLabel>{'Frame Type'}</InputLabel>
                  <Select
                    name='frameType'
                    labelId='frameType'
                    id='frameType'
                    value={values.frameType}
                    label={'Frame Type'}
                    onChange={(e) => setFieldValue('frameType', e.target.value)}
                    MenuProps={{
                      style: {
                        maxHeight: 400,
                      },
                    }}
                  >
                    {SHAPE_FRAME_TYPE?.map((type) => (
                      <MenuItem
                        key={type.name}
                        value={type.value}
                      >
                        {type.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {Boolean(touched.frameType && errors.frameType) && (
                    <FormHelperText>{errors?.frameType}</FormHelperText>
                  )}
                </FormControl>

                <TextField
                  fullWidth
                  label={'Size'}
                  name='size'
                  id='size'
                  onChange={handleChange}
                  value={values.size}
                  error={Boolean(errors.size && touched.size)}
                  helperText={
                    Boolean(errors.size && touched.size) && errors.size
                  }
                />

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={values?.topImg ? 8.5 : 12}
                    sm={values?.topImg ? 8.5 : 12}
                  >
                    <TextField
                      type='file'
                      fullWidth
                      name='topImg'
                      id='topImg'
                      onChange={(e) =>
                        handleFileChange(
                          e as React.ChangeEvent<HTMLInputElement>,
                          DocumentType.ShapeTop,
                          'topImg'
                        )
                      }
                      inputProps={{ multiple: false, accept: 'image/*' }}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      label={'Top Image'}
                      error={Boolean(errors.topImg && touched.topImg)}
                      helperText={
                        Boolean(errors.topImg && touched.topImg) &&
                        errors.topImg
                      }
                    />
                  </Grid>
                  {values?.topImg && (
                    <Grid
                      item
                      xs={3.5}
                      sm={3.5}
                    >
                      <Avatar
                        imgProps={{ crossOrigin: 'anonymous' }}
                        src={getAssetURl(values?.topImg, assetUrl)}
                        sx={{
                          borderRadius: 'unset',
                          m: 1,
                          objectFit: 'contain',
                          '& img': { objectFit: 'contain' },
                          width: { xs: '75px', sm: '100px' },
                          height: 50,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={values?.frontImg ? 8.5 : 12}
                    sm={values?.frontImg ? 8.5 : 12}
                  >
                    <TextField
                      type='file'
                      fullWidth
                      name='frontImg'
                      id='frontImg'
                      onChange={(e) =>
                        handleFileChange(
                          e as React.ChangeEvent<HTMLInputElement>,
                          DocumentType.ShapeFront,
                          'frontImg'
                        )
                      }
                      inputProps={{ multiple: false, accept: 'image/*' }}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      label={'Front Image'}
                      error={Boolean(errors.frontImg && touched.frontImg)}
                      helperText={
                        Boolean(errors.frontImg && touched.frontImg) &&
                        errors.frontImg
                      }
                    />
                  </Grid>
                  {values?.frontImg && (
                    <Grid
                      item
                      xs={3.5}
                      sm={3.5}
                    >
                      <Avatar
                        imgProps={{ crossOrigin: 'anonymous' }}
                        src={getAssetURl(values?.frontImg, assetUrl)}
                        sx={{
                          borderRadius: 'unset',
                          m: 1,
                          objectFit: 'contain',
                          '& img': { objectFit: 'contain' },
                          width: { xs: '75px', sm: '100px' },
                          height: 50,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={values?.topColorImg ? 8.5 : 12}
                    sm={values?.topColorImg ? 8.5 : 12}
                  >
                    <TextField
                      type='file'
                      fullWidth
                      name='topColorImg'
                      id='topColorImg'
                      onChange={(e) =>
                        handleFileChange(
                          e as React.ChangeEvent<HTMLInputElement>,
                          DocumentType.ShapeColorTop,
                          'topColorImg'
                        )
                      }
                      inputProps={{ multiple: false, accept: 'image/*' }}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      label={'Top Color Image'}
                      error={Boolean(errors.topColorImg && touched.topColorImg)}
                      helperText={
                        Boolean(errors.topColorImg && touched.topColorImg) &&
                        errors.topColorImg
                      }
                    />
                  </Grid>
                  {values?.topColorImg && (
                    <Grid
                      item
                      xs={3.5}
                      sm={3.5}
                    >
                      <Avatar
                        imgProps={{ crossOrigin: 'anonymous' }}
                        src={getAssetURl(values?.topColorImg, assetUrl)}
                        sx={{
                          borderRadius: 'unset',
                          m: 1,
                          objectFit: 'contain',
                          '& img': { objectFit: 'contain' },
                          width: { xs: '75px', sm: '100px' },
                          height: 50,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={values?.frontColorImg ? 8.5 : 12}
                    sm={values?.frontColorImg ? 8.5 : 12}
                  >
                    <TextField
                      type='file'
                      fullWidth
                      name='frontColorImg'
                      id='frontColorImg'
                      onChange={(e) =>
                        handleFileChange(
                          e as React.ChangeEvent<HTMLInputElement>,
                          DocumentType.ShapeColorFront,
                          'frontColorImg'
                        )
                      }
                      inputProps={{ multiple: false, accept: 'image/*' }}
                      InputLabelProps={{ shrink: true }}
                      variant='outlined'
                      label={'Front Color Image'}
                      error={Boolean(
                        errors.frontColorImg && touched.frontColorImg
                      )}
                      helperText={
                        Boolean(
                          errors.frontColorImg && touched.frontColorImg
                        ) && errors.frontColorImg
                      }
                    />
                  </Grid>
                  {values?.frontColorImg && (
                    <Grid
                      item
                      xs={3.5}
                      sm={3.5}
                    >
                      <Avatar
                        imgProps={{ crossOrigin: 'anonymous' }}
                        src={getAssetURl(values?.frontColorImg, assetUrl)}
                        sx={{
                          borderRadius: 'unset',
                          m: 1,
                          objectFit: 'contain',
                          '& img': { objectFit: 'contain' },
                          width: { xs: '75px', sm: '100px' },
                          height: 50,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>

                <TextField
                  fullWidth
                  label={'Price'}
                  name='price'
                  id='price'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.price}
                  error={Boolean(errors.price && touched.price)}
                  helperText={
                    Boolean(errors.price && touched.price) && errors?.price
                  }
                />

                <TextField
                  fullWidth
                  label={'Position'}
                  name='position'
                  id='position'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.position}
                  error={Boolean(errors.position && touched.position)}
                  helperText={
                    Boolean(errors.position && touched.position) &&
                    errors?.position
                  }
                />

                {/* <TextField
                  fullWidth
                  label={'Topping Ratio'}
                  name='toppingRatio'
                  id='toppingRatio'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.toppingRatio}
                  error={Boolean(errors.toppingRatio && touched.toppingRatio)}
                  helperText={
                    Boolean(errors.toppingRatio && touched.toppingRatio) &&
                    errors?.toppingRatio
                  }
                /> */}

                <TextField
                  fullWidth
                  label={'Discounted Price'}
                  name='discountedPrice'
                  id='discountedPrice'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.discountedPrice}
                  error={Boolean(
                    errors.discountedPrice && touched.discountedPrice
                  )}
                  helperText={
                    Boolean(
                      errors.discountedPrice && touched.discountedPrice
                    ) && errors?.discountedPrice
                  }
                />

                {/* <TextField
                  fullWidth
                  label={'Topping Price Ratio'}
                  name='toppingPriceRatio'
                  id='toppingPriceRatio'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.toppingPriceRatio}
                  error={Boolean(
                    errors.toppingPriceRatio && touched.toppingPriceRatio
                  )}
                  helperText={
                    Boolean(
                      errors.toppingPriceRatio && touched.toppingPriceRatio
                    ) && errors?.toppingPriceRatio
                  }
                /> */}

                <TextField
                  fullWidth
                  label={'Kg'}
                  name='kg'
                  id='kg'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.kg}
                  error={Boolean(errors.kg && touched.kg)}
                  helperText={Boolean(errors.kg && touched.kg) && errors?.kg}
                />
              </Box>

              <Grid
                container
                spacing={2}
                py={2}
              >
                {/* <Grid
                  item
                  xs={12}
                  sm={4}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        name='isOnDemandAllowed'
                        onChange={(e) =>
                          setFieldValue('isOnDemandAllowed', e.target.checked)
                        }
                        checked={values.isOnDemandAllowed}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                      />
                    }
                    label={'On Demand Allowed'}
                  />
                </Grid> */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                >
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={values?.previewSizeUrl ? 8.5 : 12}
                      sm={values?.previewSizeUrl ? 8.5 : 12}
                    >
                      <TextField
                        type='file'
                        fullWidth
                        name='previewSizeUrl'
                        id='previewSizeUrl'
                        inputRef={previewSizeInputRef}
                        onChange={(e) =>
                          handleFileChange(
                            e as React.ChangeEvent<HTMLInputElement>,
                            DocumentType.Shape,
                            'previewSizeUrl'
                          )
                        }
                        inputProps={{ multiple: false, accept: 'image/*' }}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                        label={'Cake Size Image'}
                        error={Boolean(
                          errors.previewSizeUrl && touched.previewSizeUrl
                        )}
                        helperText={
                          Boolean(
                            errors.previewSizeUrl && touched.previewSizeUrl
                          ) && errors.previewSizeUrl
                        }
                      />
                    </Grid>
                    {values?.previewSizeUrl && (
                      <Grid
                        item
                        xs={3.5}
                        sm={3.5}
                      >
                        <Box
                          sx={{
                            position: 'relative',
                            width: { xs: '75px', sm: '100px' },
                            mt: 1,
                          }}
                        >
                          <IconButton
                            size='small'
                            onClick={() => {
                              setFieldValue('previewSizeUrl', '');
                              if (previewSizeInputRef.current) {
                                previewSizeInputRef.current.value = '';
                              }
                            }}
                            sx={{
                              position: 'absolute',
                              top: -10,
                              right: -10,
                              zIndex: 1,
                              bgcolor: 'background.paper',
                              border: '1px solid',
                              borderColor: 'divider',
                              '&:hover': {
                                bgcolor: 'grey.100',
                              },
                            }}
                          >
                            <CloseIcon fontSize='small' />
                          </IconButton>
                          <Avatar
                            imgProps={{ crossOrigin: 'anonymous' }}
                            src={getAssetURl(values?.previewSizeUrl, assetUrl)}
                            sx={{
                              borderRadius: 'unset',
                              objectFit: 'contain',
                              '& img': { objectFit: 'contain' },
                              width: { xs: '75px', sm: '100px' },
                              height: 50,
                            }}
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        name='activeState'
                        onChange={(e) =>
                          setFieldValue('activeState', e.target.checked)
                        }
                        checked={values.activeState}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                      />
                    }
                    label={'Active Status'}
                  />
                </Grid>
                {/* <Grid
                  item
                  xs={12}
                  sm={4}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        name='isNew'
                        onChange={(e) =>
                          setFieldValue('isNew', e.target.checked)
                        }
                        checked={values.isNew}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                      />
                    }
                    label={'New'}
                  />
                </Grid> */}
              </Grid>

              <Stack
                alignItems='center'
                sx={{ mt: 3 }}
                direction='row'
                justifyContent='flex-end'
                gap={1}
              >
                <Button
                  variant='outlined'
                  onClick={() => navigation('/shape')}
                >
                  {'Cancel'}
                </Button>

                <LoadingButton
                  type='submit'
                  variant='contained'
                  loading={isSubmitting}
                >
                  {isAddMode ? 'Add Shape' : 'Edit Shape'}
                </LoadingButton>
              </Stack>
            </Card>
          </form>
        )}
      </Grid>
    </Grid>
  );
};

export default ShapeForm;
